import { Link } from "react-router-dom";
import { ArrowDown, MessageCircle } from "lucide-react";
import ContourBackground from "@/components/ContourBackground";
import { disciplineIcon } from "./disciplineIcons";

/** Discipline landing hero: keyword H1, intro, CTAs, keyword chips + stat panel. */
export default function DisciplineHero({ d }) {
  const Icon = disciplineIcon(d);
  return (
    <section className="relative overflow-hidden border-b border-slate-200 bg-paper-dark/40" data-testid="discipline-hero">
      <ContourBackground variant="light" opacity={0.5} seed={d.slug.length * 7} />
      <div className="relative mx-auto max-w-7xl px-6 lg:px-10 py-16 lg:py-24 grid grid-cols-1 lg:grid-cols-12 gap-12 items-end">
        <div className="lg:col-span-8">
          <Link to="/disciplines" className="mono text-[10px] tracking-[0.22em] uppercase text-topo inline-flex items-center gap-2 hover:text-orange-survey" data-testid="discipline-eyebrow">
            <Icon className="h-3.5 w-3.5" /> Disciplines · {d.eyebrow}
          </Link>
          <h1 className="display mt-4 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tighter text-slate-900 leading-[1.02]" data-testid="discipline-h1">
            {d.h1.pre}<span className="text-topo">{d.h1.em}</span>{d.h1.post}
          </h1>
          <p className="mt-6 max-w-2xl text-base sm:text-lg text-slate-600 leading-relaxed">{d.intro}</p>
          <div className="mt-8 flex flex-wrap gap-3">
            <a href="#discipline-quote" data-testid="discipline-cta-quote" className="inline-flex items-center gap-2 rounded-sm bg-orange-survey hover:bg-orange-survey-dark text-white text-sm font-semibold px-5 py-3 transition-colors">
              Get a fixed quote <ArrowDown className="h-4 w-4" />
            </a>
            <a href="https://wa.me/918083691588" target="_blank" rel="noopener noreferrer" data-testid="discipline-cta-whatsapp" className="inline-flex items-center gap-2 rounded-sm border border-slate-900 text-slate-900 hover:bg-slate-900 hover:text-white text-sm font-semibold px-5 py-3 transition-colors">
              <MessageCircle className="h-4 w-4" /> WhatsApp us
            </a>
          </div>
          <div className="mt-8 flex flex-wrap gap-2" data-testid="discipline-keywords">
            {d.keywords.map((k) => (
              <span key={k} className="mono text-[10px] tracking-wide uppercase border border-slate-300 bg-white text-slate-700 px-2.5 py-1">{k}</span>
            ))}
          </div>
        </div>
        <dl className="lg:col-span-4 border border-slate-900 bg-white divide-y divide-slate-200" data-testid="discipline-stats">
          {d.stats.map((s) => (
            <div key={s.label} className="px-6 py-5">
              <dt className="mono text-[10px] tracking-[0.22em] uppercase text-slate-500">{s.label}</dt>
              <dd className="display mt-1 text-2xl font-extrabold tracking-tight text-slate-900">{s.value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}
